import Translation from 'components/Translation'
import { AuthContext, useAuth } from 'context/AuthContext'
import { useEffect } from 'react'
import { classNames } from 'utils/dom-helpers'
import { createModal } from './ModalFactory'
import { ModalWrapper } from './ModalWrapper'

export enum GlobalDialogType {
    SUCCESS = 'feather-check bg-emerald-500 text-white',
    ALERT = 'feather-alert-triangle bg-red-800 text-white ',
}

const ModalProvider = createModal(
    AuthContext,
    'GlobalDialog',
    () => (
        <>
            <i className="feather feather-plus mr-4" />
            <span className="circular"></span>
        </>
    ),
    () => (
        <span className="inline-block w-6 h-6 text-primary text-center font-extralight">
            <i className="feather feather-x " />
        </span>
    )
)

export const GlobalDialogOpener = ModalProvider.Opener
export const GlobalDialogCloser = ModalProvider.Closer

export default function GlobalDialog() {
    const { GlobalDialog } = useAuth()
    const { attributes, setAttributes } = GlobalDialog

    useEffect(() => {
        if (!GlobalDialog.is_open) {
            setAttributes({})
        }
    }, [GlobalDialog.is_open])

    return (
        <ModalProvider.Visible>
            <ModalWrapper
                className={(attributes?.className as string) || 'w-auto'}
                zIndex="z-[510]"
            >
                <div className="bg-white shadow-2xl overflow-x-hidden sm:rounded-md relative border-2 border-gray-100 my-auto w-full xl:w-3/4 mx-auto text-center p-5">
                    {attributes?.type && (
                        <div className="p-5">
                            <i
                                className={classNames(
                                    attributes?.type as string,
                                    'rounded-full w-10 h-10 block m-auto pt-1.5 text-lg content-center'
                                )}
                            />
                        </div>
                    )}
                    <div className="circular inline-block self-center text-4xl text-primary-dark mx-auto mb-5">
                        <Translation
                            content_key={attributes?.title as string}
                            content_values={attributes?.title_content_values as Record<string, string>}
                        />
                    </div>
                    {attributes?.message &&
                        <div className='flex'>
                            <p className={classNames(attributes?.messageClassName as string,
                                "bg-green-200/50 text-green-700 p-3 rounded-full items-center flex m-auto justify-center text-xs"
                            )}>
                                <Translation
                                    content_key={attributes?.message as string}
                                    content_values={attributes?.message_content_values as Record<string, string>} 
                                />
                            </p>
                        </div>
                    }

                    <div className="mx-auto w-1/2 py-8">
                        <button
                            type="button"
                            className="bg-primary border border-gray-300 w-full text-white capitalize rounded-lg inline-block py-3 px-8"
                            onClick={() => {
                                GlobalDialog.close()
                            }}
                        >
                            <Translation
                                content_key={
                                    (attributes?.button as string) || 'ok'
                                }
                            />
                        </button>
                    </div>
                </div>
            </ModalWrapper>
        </ModalProvider.Visible>
    )
}
